import Skeleton from '@mui/material/Skeleton';
import { Box } from 'shared/mui/Box';
import { CardTable } from 'shared/mui/Card/CardTableNew/CardTable';
import { Stack } from 'shared/mui/Stack/Stack';
import { TableRowWrapper } from 'shared/mui/Table/TableRowWrapperNew/TableRowWrapper';

export const RequestsBankOpsShowSkeleton: React.FC = () => {
  return (
    <>
      <Stack direction="row" gap={1} sx={{ marginBottom: '24px' }}>
        {Array.from({ length: 4 }).map((_, index) => (
          <Skeleton height={24} key={index} variant="rounded" width={110} />
        ))}
      </Stack>
      <Box sx={{ borderBottom: 1, borderColor: 'divider', marginBottom: '24px' }}>
        <Stack alignItems="center" direction="row" gap={4} sx={{ height: '48px' }}>
          {Array.from({ length: 4 }).map((_, index) => (
            <Skeleton height={20} key={index} variant="rounded" width={180} />
          ))}
        </Stack>
      </Box>
      <CardTable tableBodyProps={{ sx: { '& td': { width: '208px' } } }}>
        {Array.from({ length: 9 }).map((_, index) => (
          <TableRowWrapper key={index} label={<Skeleton />}>
            <Skeleton />
          </TableRowWrapper>
        ))}
      </CardTable>
    </>
  );
};
